module.exports = __webpack_public_path__ + "img/purplevert.35c4f714.png";